import React, { useEffect } from 'react';
import {
  withClickTrack,
  withTrackComponentDisplayed,
  useFlow,
} from '@edreamsodigeo/frontend-core';
import { useIsWebView } from '@/hooks/useIsWebView';

const cache = {};

export const withDatameshLoad = (Component, id) => {
  const ComponentWithTracking = withTrackComponentDisplayed(Component);
  const eventBuilder = buildEventId(id);

  return (props) => {
    const platform = useFlow();
    const isNative = useIsWebView();
    const eventId = eventBuilder(isNative ? 'native' : platform);

    useEffect(() => {
      cache[id] = true;
      return () => {
        cache[id] = false;
      };
    }, []);

    return !cache[id] ? (
      <ComponentWithTracking {...props} html-event-id={eventId} />
    ) : (
      <Component {...props} />
    );
  };
};

export const withLoadPlaceholder = (id) => {
  const LoadComponent = withDatameshLoad(() => <></>, id);
  return () => {
    return <LoadComponent />;
  };
};

export const withDatameshClick = (Component, id) => {
  const ComponentWithTracking = withClickTrack(Component);
  const eventBuilder = buildEventId(id);

  return (props) => {
    const platform = useFlow();
    const isNative = useIsWebView();
    const eventId = eventBuilder(isNative ? 'native' : platform);

    return id ? (
      <ComponentWithTracking
        onClick={() => {}}
        {...props}
        html-event-id={eventId}
      />
    ) : (
      <Component {...props} />
    );
  };
};

const buildEventId = (id) => (platform) => `${id}:${platform}`;
